import createIcon from '../../createIcon';

/**
 * @component @name ArrowLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSA3TDkuNSAxMkwxNC41IDE3VjdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ArrowLeft = createIcon('ArrowLeft', [
  ['path', { d: 'M14.5 7L9.5 12L14.5 17V7Z', key: '1kehke' }],
]);

export default ArrowLeft;
